// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"449":"resort-list","907":"map-content"}[chunkId] + "." + __webpack_require__.h() + ".css";
};